import * as React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Notice } from '../../types/index'
import moment from 'moment'



export default function NoticeCompoment(props: {
  title: string
  notices: Notice[]
}) {

  const { title, notices } = props


  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          backgroundColor: '#f9f9f9',
        }}
      />
      <Grid container>
        <Grid item md={12}>
          <Box
            sx={{
              position: 'relative',
            }}
          >
            <Typography component="h1" variant="h4" color="inherit" gutterBottom
              sx={{
                textAlign: "center",
                borderBottom: 2,
                borderColor: 'black',
                p: { xs: 1, md: 2 },
                pr: { md: 0 },
                fontWeight: "bold",
              }}>
              {title}
            </Typography>
            <Box
              style={{ maxHeight: 300, overflow: 'auto' }}
            >
              {notices.length > 0 ? notices.map((notice, index) => (
                <Typography
                  variant="h6"
                  color="inherit"
                  paragraph
                  sx={{
                    borderBottom: 1,
                    borderColor: 'black',
                    color: "#dd0000",
                    fontWeight: "bold",
                    fontSize: "18px"
                  }}
                  key={index}
                >
                  {/* DBの登録時間がおかしいので、フロントで無理やり合わせる */}
                  <span dangerouslySetInnerHTML={{ __html: `${moment(notice.created_at).add(9, "hour").format("YYYY/MM/DD HH:mm:ss")} ${notice.detail}` }}></span>
                </Typography>
              )) : (
                <Typography variant="h6" color="inherit" paragraph sx={{
                  borderBottom: 1,
                  borderColor: 'black',
                  color: "#dd0000",
                  fontWeight: "bold",
                  fontSize: "18px"
                }}>
                  <span>お知らせはありません</span>
                </Typography>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}